import * as API from '@/services/API';
import router from '@/router';

export default {
  list({ commit }, params) {
    return API.apiClient
      .get('/opportunities', { params: params })
      .then((response) => {
        commit('SET_LIST', response.data.data);
        return response.data.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  async view({ commit }, id) {
    commit('SET_LOADING', true);
    return await API.apiClient
      .get('/opportunities/' + id)
      .then((response) => {
        commit('SET_CURRENT_OPPORTUNITY', response.data);
        commit('SET_LOADING', false);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        commit('SET_LOADING', false);
        router.push({ name: 'Error' });
      });
  },
  add({ commit, dispatch }, payload) {
    return API.apiClient
      .post('/opportunities', payload)
      .then((response) => {
        dispatch('list');
        dispatch('view', response.data.id);
        if (response.data.lead_id) {
          let lead = {
            id: response.data.lead_id,
            status: 'converted',
          };
          dispatch('leads/update', lead, { root: true });
        }
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  update({ commit, dispatch }, payload) {
    return API.apiClient
      .put('/opportunities/' + payload.id, payload)
      .then((response) => {})
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  bulkUpdate({ commit }, payload) {
    return API.apiClient
      .put('opportunities/bulk-update', payload)
      .then((response) => {})
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  destroy({ commit, dispatch }, id) {
    return API.apiClient
      .delete('/opportunities/' + id)
      .then((response) => {
        dispatch('list');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
